<template>
  <ul>
    <NavigationEntry
      v-for="item in items"
      :key="item.name"
      :show-pin="showPin"
      :item="item"
    />
  </ul>
</template>

<script>
import NavigationEntry from 'src/components/navigation/navigation_entry.vue'

// Entries of the navigation (lists, bookmark folders, followed tags), each
// pinnable while the navigation is edited
export default {
  components: { NavigationEntry },
  props: {
    items: { type: Array, required: true },
    showPin: Boolean,
  },
}
</script>
